<template>
	<div class="main">
		<a-table :columns="columns" :data-source="tableData" bordered :pagination="false" class="tree-table">
			<template slot="position" slot-scope="scope">
				<span>{{ scope.name }}</span>
			</template>
			<template slot="timeSlot" slot-scope="scope">
				<!-- 原版 -->
				<!-- <div class="timeSlotItem" v-if="scope.monitorOutBedStatus == 1">
          <div class="timeSlot" v-if="scope.monitorTimes">
            <div class="timeSlotItem" v-for="(item, index) in scope.monitorTimes" :key="index">
              <span :style="{color: scope.monitorTimeUnified == 1 ? '#262626' : '#BFBFBF',}">{{ item.startTime }} - {{ item.endTime }}</span>
              <a-icon type="form" class="tableIcon" @click="timeSlotBtn(scope, 2, item)" style="margin-right: 10px" />
              <div class="tableImg" v-if="scope.monitorTimes.length > 1" @click="delbtn(scope, item)"></div>
              <div v-else class="kong"></div>

              <div class="addBtn" v-if="index === 0" @click="timeSlotBtn(scope, 1)">
                <a-icon type="plus-circle" theme="filled" class="iconBtn" />添加时段
              </div>
            </div>
          </div>
          <div v-if="!scope.monitorTimes" class="timeSlot">
            <div class="timeSlotItem">
              <div class="addBtn" @click="timeSlotBtn(scope, 1)">
                <a-icon type="plus-circle" theme="filled" class="iconBtn" />添加时段
              </div>
            </div>
          </div>
        </div> -->

				<!-- 新版 -->
				<div class="timeSlotItem" v-if="scope.monitorOutBedStatus == 1
					">
					<div class="timeSlot" v-if="scope.monitorTimes">
						<div class="timeSlotItem" v-for="(item, index) in scope.monitorTimes" :key="index">
							<img v-if="scope.monitorTimeUnified == 1 && item.outBedPhoneEnable == 0" class="timeSlotItemPhone" src="../../assets/icon_admin_radar_word_deploy_phone_1.png" alt="" />
							<span :style="{
								color: scope.monitorTimeUnified == 1 ? '#262626' : '#BFBFBF',
							}">{{ item.startTime }} - {{ item.endTime }}</span>
							<!-- <span v-if="(scope.type != 1 || (scope.type == 1 && scope.radarType == 1)) && item.outBedAlarmTime" :style="{ color: scope.outBedTimeoutUnified == 1 ? '#262626' : '#BFBFBF' }"
							style="text-align: right; margin-left: 10px;">{{ '离床异常：' + item.outBedAlarmTime }}</span> -->
							<span :style="{
								color: scope.monitorTimeUnified == 1 ? '#262626' : '#BFBFBF',
							}" style="margin-left: 10px; font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #999999; line-height: 20px;">{{ '离床异常：' + (item.outBedEnable == 1  ? '未开启' : item.outBedAlarmTime) }}</span>
							<a-icon type="form" class="tableIcon" @click="timeSlotBtn(scope, 2, item)" style="margin-right: 10px" />
							<div class="tableImg" v-if="scope.monitorTimes.length > 1" @click="delbtn(scope, item)"></div>
							<div v-else class="kong"></div>

							<div class="addBtn" v-if="index === 0" @click="timeSlotBtn(scope, 1)">
								<a-icon type="plus-circle" theme="filled" class="iconBtn" />添加时段
							</div>
						</div>
					</div>
					<div v-if="!scope.monitorTimes" class="timeSlot">
						<div class="timeSlotItem">
							<div class="addBtn" @click="timeSlotBtn(scope, 1)">
								<a-icon type="plus-circle" theme="filled" class="iconBtn" />添加时段
							</div>
						</div>
					</div>
				</div>

				<!-- bedMonitorTimeConsumerVO存在为c端数据，只显示不可修改 -->
				<!-- <div class="timeSlotItem" v-if="scope.bedMonitorTimeConsumerVO && scope.monitorOutBedStatus == 1
					">
					<div class="timeSlot" v-if="scope.bedMonitorTimeConsumerVO.monitorTimes"> -->
				<!-- <div class="timeSlotItem" v-for="(item, index) in scope.monitorTimes" :key="index"> -->
				<!-- <div class="timeSlotItem" v-for="(item, index) in scope.bedMonitorTimeConsumerVO
							.monitorTimes" :key="index">
							<span :style="{
								color: scope.monitorTimeUnified == 1 ? '#262626' : '#BFBFBF',
							}">{{ item.startTime }} - {{ item.endTime }}</span>
						</div>
					</div>
				</div> -->
			</template>

			<template slot="abnormal" slot-scope="scope">

				<div class="abnormal" style="justify-content: center;">
					<div style="display: flex; flex-direction: column; width: 58px;">
						<!-- <span v-if="(scope.type != 1 || (scope.type == 1 && scope.radarType == 1)) && scope.outBedTime" :style="{ color: scope.outBedTimeoutUnified == 1 ? '#262626' : '#BFBFBF' }"
							style="text-align: right;">{{ '离床异常：' + scope.outBedTime }}</span> -->
						<span v-if="(scope.type != 1 || (scope.type == 1 && scope.radarType == 2)) && scope.outToiletTimeout" style="text-align: center;" :style="{
							color: scope.outToiletTimeoutUnified == 1 ? '#262626' : '#BFBFBF'
						}">
							<!-- {{
								Number(scope.outToiletTimeout.split(':')[0] * 3600) +
								Number(scope.outToiletTimeout.split(':')[1] * 60) +
								Number(scope.outToiletTimeout.split(':')[2]) >
								600
								? '卫生间停留异常：' + scope.outToiletTimeout.slice(0, 5) + ':--'
								: '卫生间停留异常：' + '00:10:--'
							}} -->
							{{ scope.outToiletTimeout.slice(0, 5) + ':--' }}
						</span>
					</div>
					<a-icon v-if="(scope.type == 2 || scope.type == 3 || scope.type == 4 || (scope.type == 1 && (scope.radarType == 2)))" type="form" @click="scope.type != 1 ?  allSet(scope) : scope.radarType == 2 ? setToitet(scope) : abnormalBtn(scope)" class="tableIcon" />
				</div>

				<!-- 原版 -->
				<!-- <div class="abnormal" v-if="scope.monitorOutBedStatus == 1">
          <span :style="{
              color: scope.outBedTimeoutUnified == 1 ? '#262626' : '#BFBFBF',
            }">{{ scope.outBedTime }}</span>
          <a-icon type="form" @click="abnormalBtn(scope)" class="tableIcon" />
        </div> -->

				<!-- 新版 -->
				<!-- 去掉C端判断 !scope.bedMonitorTimeConsumerVO &&  scope.monitorOutBedStatus == 1 -->
				<!-- 注释：新版要展示离床异常时间端和卫生间停留异常时间端，老板只展示一个 -->
				<!-- <div class="abnormal" v-if="scope.radarType !== 2
					">
					<span :style="{
						color: scope.outBedTimeoutUnified == 1 ? '#262626' : '#BFBFBF',
					}">{{ scope.outBedTime }}</span>
					<a-icon type="form" @click="abnormalBtn(scope)" class="tableIcon" />
				</div>
				<div v-if="scope.radarType == 2" class="toitet-edit">
					<span>
						{{
							Number(scope.outBedTime.split(':')[0] * 3600) +
							Number(scope.outBedTime.split(':')[1] * 60) +
							Number(scope.outBedTime.split(':')[2]) >
							600
							? scope.outBedTime.slice(0, 5) + ':--'
							: '00:10:--'
						}}
					</span>
					<a-icon type="form" @click="setToitet(scope)" class="tableIcon" />
				</div> -->

				<!-- <div v-if="scope.bedMonitorTimeConsumerVO && scope.monitorOutBedStatus == 1
					">
					<div v-if="scope.monitorOutBedStatus == 1">
						<div class="abnormal" :key="ouIndex" v-for="(ouItem, ouIndex) in scope.bedMonitorTimeConsumerVO
							.outBedAlarmTimes">
							<span :style="{
								color:
									scope.outBedTimeoutUnified == 1 ? '#262626' : '#BFBFBF',
							}">{{ ouItem.outBedTime }}</span>
						</div>
					</div>
				</div> -->
			</template>
		</a-table>

		<!-- 添加监测时间 + 修改监测时间 -->
		<a-modal :title="numType == 1 ? '添加监测时间' : '修改监测时间'" :width="400" :visible="editHandleTimePopup" :footer="null"
			:closable="false">
			<div class="picker">
				<div class="titleTime">开始时间</div>
				<a-time-picker :open.sync="open" class="acol_statr_input" format="HH:mm" v-model="startTime" :allowClear="false">
					<a-button slot="addon" size="small" type="primary" @click="handleClose" style="margin-left:45px">
						确定
					</a-button>
				</a-time-picker>
			</div>
			<div class="picker">
				<div class="titleTime">终止时间</div>
				<a-time-picker :open.sync="open2" class="acol_statr_input" format="HH:mm" v-model="endTime" :allowClear="false">
					<a-button slot="addon" size="small" type="primary" @click="handleClose" style="margin-left:45px">
						确定
					</a-button>
				</a-time-picker>
			</div>
			<div class="picker">
				<div class="titleTime">离床异常时长</div>
				<a-switch checked-children="开" un-checked-children="关" :checked="leaveBedTimeSwitch" @change="leaveBedTimeSwitchChange" />
				<a-time-picker :allowClear="false" v-model="editHandleTimeVal" format="HH:mm:ss" style="margin-left: 10px;" :style="{opacity: leaveBedTimeSwitch ? 1 : 0.3}" :disabled="!leaveBedTimeSwitch"></a-time-picker>
			</div>
			<div class="picker">
				<div class="titleTime">离床电话报警</div>
				<a-switch checked-children="开" un-checked-children="关" :checked="leaveBedPhoneAlarmSwitch" @change="leaveBedPhoneAlarmSwitchChange" />
			</div>
			<div class="addBtn">
				<a-button style="margin-right: 10px" @click="editHandleTimeCancel">取消</a-button>
				<a-button type="primary" @click="editHandleTimeOk(1)" :loading="loading">确定</a-button>
			</div>
		</a-modal>

		<!-- 修改离床异常时间 + 卫生间停留异常时间 -->
		<a-modal title="修改离床异常时长" :width="400" :visible="editAbnormalTimeAll" :maskClosable="false" :footer="null"
			@cancel="allSetCancel">
			<!-- <div class="picker">
				<div class="titleTime">离床异常时长</div>
				<a-time-picker :allowClear="false" v-model="editHandleTimeVal" format="HH:mm:ss"></a-time-picker>
			</div> -->
			<div class="picker">
				<div class="titleTime">卫生间停留异常时长</div>
				<!-- <el-time-picker v-model="editHandleTimeValToitet2" format="HH:mm:ss" value-format="HH:mm" :picker-options="{selectableRange: '00:10:00 - 23:59:59', minTime: '00:10'}" >
				</el-time-picker> -->
				<a-time-picker 
				:allowClear="false" 
				v-model="editHandleTimeValToitet2" 
				format="HH:mm:ss" 
				value-format="HH:mm" 
				:picker-options="{selectableRange: '00:10:00 - 23:59:59', minTime: '00:10'}" 
				:secondStep="60" 
				:disabledHours="getDisabledHours"
				:disabledMinutes="getDisabledMinutes"
				:disabledSeconds="getDisabledSeconds"
				:hideDisabledOptions="true"></a-time-picker>
			</div>
			<div class="toitet-pop-tips" style="margin-top: -15px;">
				<div>*仅能设置“时”和“分”</div>
				<div :class="isLessTime ? 'isLessTime' : ''">*最短只能设置到10分钟</div>
			</div>
			<div class="addBtn">
				<a-button style="margin-right: 10px; margin-top: 15px;" @click="allSetCancel">取消</a-button>
				<a-button type="primary" @click="allSetSure(2)" :loading="loading">确定</a-button>
			</div>
		</a-modal>

		<!-- 修改离床异常时间 -->
		<a-modal title="修改离床异常时间" :width="400" :visible="editAbnormalTimePopup" :maskClosable="false" :footer="null"
			@cancel="editAbnormalTimeCancel">
			<div class="picker">
				<div class="titleTime">离床异常时间</div>
				<a-time-picker :allowClear="false" v-model="editHandleTimeVal" format="HH:mm:ss"></a-time-picker>
			</div>
			<div class="addBtn">
				<a-button style="margin-right: 10px" @click="editAbnormalTimeCancel">取消</a-button>
				<a-button type="primary" @click="editAbnormalTimeOk(2)" :loading="loading">确定</a-button>
			</div>
		</a-modal>

		<!-- 修改停留时长异常时间 -->
		<a-modal title="修改卫生间停留异常时长" :width="400" :visible="editAbnormalTimePopupToitet" :maskClosable="false" :footer="null"
			@cancel="editAbnormalTimeCancelToitet">
			<div class="picker">
				<div class="titleTime">卫生间停留异常时长</div>
				<el-time-picker v-model="editHandleTimeValToitet2" format="HH:mm:ss" value-format="HH:mm">
				</el-time-picker>
			</div>
			<div class="toitet-pop-tips">
				<div>*仅能设置“时”和“分”</div>
				<div :class="isLessTime ? 'isLessTime' : ''">*最短只能设置到10分钟</div>
			</div>
			<div class="addBtn toitet-btn">
				<a-button style="margin-right: 10px" @click="editAbnormalTimeCancelToitet">取消</a-button>
				<a-button type="primary" @click="editAbnormalTimeToitet" :loading="loading">确定</a-button>
			</div>
		</a-modal>

		<!-- 删除弹窗 -->
		<a-modal title="" :width="200" :visible="delPopup" :footer="null" :closable="false">
			<p class="delTips">
				<a-icon type="exclamation-circle" />你确定要删除吗？
			</p>
			<div class="delBtn">
				<a-button style="margin-right: 10px" @click="delCancel">取消</a-button>
				<a-button type="primary" @click="delOk" :loading="loading">确定</a-button>
			</div>
		</a-modal>
		<!-- 修改监测时间or修改离床异常时间二次确认弹窗 -->
		<a-modal :width="400" :visible="secondaryPopup" @cancel="secondaryCancel" :footer="null" :zIndex="2000">
			<div class="Tips">
				<a-icon type="exclamation-circle" style="color: #faad14" />
				<p>
					该设置会针对整个“{{
						typeData.name
					}}”的监测仪生效，操作后不可取消，确定操作？
				</p>
			</div>
			<div class="secondaryBtn">
				<a-button style="margin-right: 10px" @click="secondaryCancel">取消</a-button>
				<a-button type="primary" @click="secondaryTimeOk" :loading="loading">确定</a-button>
			</div>
		</a-modal>
		<!-- 删除二次确定弹窗 -->
		<a-modal :width="400" :visible="delSecondaryPopup" @cancel="delSecondaryCancel" :footer="null" :zIndex="2000">
			<div class="Tips">
				<a-icon type="exclamation-circle" style="color: #faad14" />
				<p>
					即将删除整个“{{
						typeData.name
					}}”监测仪的设置，操作后不可取消，确定操作？
				</p>
			</div>
			<div class="secondaryBtn">
				<a-button style="margin-right: 10px" @click="delSecondaryCancel">取消</a-button>
				<a-button type="primary" @click="delSecondaryOk" :loading="loading">确定</a-button>
			</div>
		</a-modal>
	</div>
</template>

<script>
const columns = [
	{
		title: '位置',
		align: 'left',
		width: '340px',
		scopedSlots: { customRender: 'position' },
	},
	{
		title: '监测时间段设置',
		align: 'left',
		scopedSlots: { customRender: 'timeSlot' },
	},
	{
		title: '卫生间停留异常时长',
		width: '287px',
		align: 'center',
		scopedSlots: { customRender: 'abnormal' },
	},
];
export default {
	data() {
		return {
			columns,
			tableData: [],
			editHandleTimePopup: false, // 修改监测仪时间段弹窗
			editAbnormalTimeAll: false,
			editAbnormalTimePopup: false, // 离床异常时间弹窗
			editAbnormalTimePopupToitet: false, // 离床异常时间弹窗
			secondaryPopup: false, // 二次确定弹窗
			delSecondaryPopup: false, // 删除二次确认弹窗
			delPopup: false, // 删除弹窗
			typeData: {}, // 当前点击行数据
			startTime: '', // 开始时间
			endTime: '', // 终止时间
			loading: false,
			editHandleTimeVal: '', // 离床异常时间值
			editHandleTimeValToitet: '', // 卫生间异常时间值
			editHandleTimeValToitet2: '', // 卫生间异常时间值
			typeVal: '', // 为了做区分
			numType: '',
			monitorTimeId: '', // 修改时间段id
			delitem: '', // 删除信息
			isClick: null,
			isClick1: null,
			open: false,
			open2: false,
			toitetTypeData: 2, // 卫生间停留过久类型
			toitetId: '', // 卫生间停留过久设备id
			isLessTime: false, // 卫生间停留过久是否小于10分钟

			leaveBedTimeSwitch: false,
			leaveBedPhoneAlarmSwitch: false
		};
	},
	watch: {
		editHandleTimeValToitet2(newEditHandleTimeValToitet2, oldEditHandleTimeValToitet2) {
			
			if (newEditHandleTimeValToitet2 == '00:00' || newEditHandleTimeValToitet2 == '00:01' || newEditHandleTimeValToitet2 == '00:02' || newEditHandleTimeValToitet2 == '00:03' || newEditHandleTimeValToitet2 == '00:04' || newEditHandleTimeValToitet2 == '00:05' || newEditHandleTimeValToitet2 == '00:06' || newEditHandleTimeValToitet2 == '00:07' || newEditHandleTimeValToitet2 == '00:08' || newEditHandleTimeValToitet2 == '00:09') {
				this.editHandleTimeValToitet2 = '00:10'
			}
		}
	},
	mounted() {
		this.getTableData();
	},
	methods: {
		allSet(scopeData) {
			console.log(scopeData);
			this.editHandleTimeValToitet2 = scopeData.outToiletTimeout;
			this.toitetTypeData = scopeData.type;
			this.toitetId = scopeData.id;

			this.isClick1 = true;
			this.typeData = scopeData;
			this.editHandleTimeVal = scopeData.outBedTime
				? this.$moment(scopeData.outBedTime, 'HH:mm:ss')
				: '';

			this.editAbnormalTimeAll = true;
		},
		allSetCancel() {
			this.editAbnormalTimeAll = false;
		},
		allSetSure() {
			// 离床异常时长

			// 卫生间长时间停留时长
			let time =
				Number(this.editHandleTimeValToitet2.split(':')[0] * 3600) +
				Number(this.editHandleTimeValToitet2.split(':')[1] * 60);
			if (time < 600 || !this.editHandleTimeValToitet2) {
				this.isLessTime = true;
				return false;
			}
			this.isLessTime = false;

			let needOutToiletTimeout = this.editHandleTimeValToitet2;
			const regex = /:/g;
			const matches = needOutToiletTimeout.match(regex);
			if (matches && matches.length < 2) {
				needOutToiletTimeout = needOutToiletTimeout + ':00'
			}

			// 公共
			let param = {
				objId: this.toitetId,
				type: this.toitetTypeData + '',
				// outBedTimeout: this.$dateTime(this.editHandleTimeVal._d).time + ':' + this.$dateTime(this.editHandleTimeVal._d).seconds,
				outToiletTimeout: needOutToiletTimeout
			};
			this.loading = true;
			this.$put(
				'/api/monitorMgr/updateOutBedToiletTimeout',
				param,
				(res) => {
					if (res.code == 0) {
						this.$message.success('修改成功');
						this.getTableData();
						this.editAbnormalTimePopup = false;
						this.secondaryPopup = false;
						this.editAbnormalTimePopupToitet = false;
						this.editAbnormalTimeAll = false;

					}
					this.loading = false;
				},
				(err) => {
					console.log(err);
					this.loading = false;
					// this.$message.error('服务端发生异常');
				}
			);
		},
		// 设置卫生间停留时长
		setToitet(scopeData) {
			console.log(scopeData);
			this.editAbnormalTimePopupToitet = true;
			this.editHandleTimeValToitet2 = scopeData.outToiletTimeout;
			this.toitetTypeData = scopeData.type;
			this.toitetId = scopeData.id;
		},
		// 卫生间停留时长取消
		editAbnormalTimeCancelToitet() {
			this.editAbnormalTimePopupToitet = false;
		},
		// 卫生间停留时长确定
		editAbnormalTimeToitet() {
			let time =
				Number(this.editHandleTimeValToitet2.split(':')[0] * 3600) +
				Number(this.editHandleTimeValToitet2.split(':')[1] * 60);
			console.log(time || !this.editHandleTimeValToitet2);
			if (time < 600) {
				this.isLessTime = true;
				return false;
			}
			this.isLessTime = false;
			let needOutToiletTimeout = this.editHandleTimeValToitet2;
			const regex = /:/g;
			const matches = needOutToiletTimeout.match(regex);
			if (matches && matches.length < 2) {
				needOutToiletTimeout = needOutToiletTimeout + ':00'
			}
			let param = {
				objId: this.toitetId,
				outToiletTimeout: needOutToiletTimeout,
				type: this.toitetTypeData + '',
			};
			this.loading = true;
			this.$put(
				'/api/monitorMgr/updateOutBedToiletTimeout',
				param,
				(res) => {
					if (res.code == 0) {
						this.$message.success('修改成功');
						this.getTableData();
						this.editAbnormalTimePopup = false;
						this.secondaryPopup = false;
						this.editAbnormalTimePopupToitet = false;
					}
					this.loading = false;
				},
				(err) => {
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},
		handleClose() {
			this.open = false;
			this.open2 = false;
		},
		// 获取table树数据
		getTableData() {
			this.$get(
				'/api/monitorMgr',
				{},
				(res) => {
					if (res.code == 0) {
						this.tableData = res.data;
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},
		// 监测仪时间段按钮
		timeSlotBtn(scope, num, item) {

			if (item) {
				this.editHandleTimeVal = item.outBedAlarmTime ? this.$moment(item.outBedAlarmTime, 'HH:mm:ss') : '';
				this.leaveBedTimeSwitch = item.outBedEnable == 0 ? true : false;
				this.leaveBedPhoneAlarmSwitch = item.outBedPhoneEnable == 0 ? true : false;
			} else {
				this.editHandleTimeVal = '';
				this.leaveBedTimeSwitch = false;
				this.leaveBedPhoneAlarmSwitch = false;
			}

			this.editHandleTimePopup = true;
			this.typeData = scope;
			this.numType = num;
			this.isClick = scope.children ? true : false;
			if (num == 2) {
				this.monitorTimeId = item;
				this.startTime = this.$moment(item.startTime, 'HH:mm:ss'); // 开始时间
				this.endTime = this.$moment(item.endTime, 'HH:mm:ss'); // 终止时间
				return;
			}
			this.startTime = ''; // 开始时间
			this.endTime = ''; // 终止时间
		},
		// 监测仪时间段确定
		editHandleTimeOk(type) {
			if (type == 1 && this.leaveBedTimeSwitch == true && (!this.editHandleTimeVal || '')) {
				this.$message.error('请设置离床异常时长');
				return
			}
			console.log(this.isClick);
			if (this.isClick) {
				this.secondaryPopup = true;
				this.typeVal = type;
			} else {
				if (this.numType == 1) {
					this.addWorkTime();
				} else {
					this.editWorkTime();
				}
			}
		},
		// 取消修改
		editHandleTimeCancel() {
			this.editHandleTimePopup = false;
		},
		// 二次确定提交
		secondaryTimeOk() {
			if (this.typeVal == 1) {
				// 监测仪时间段
				if (this.numType == 1) {
					//新增
					this.addWorkTime();
				} else {
					// 修改/api/monitorMgr/workTime
					this.editWorkTime();
				}
			} else {
				// 修改离床异常时间
				this.editOutBedTimeout();
			}
		},
		// 新增监测仪时间段
		addWorkTime() {
			let param = {
				startTime: this.startTime._d ? this.$dateTime(this.startTime._d).time : '',
				endTime: this.endTime._d ? this.$dateTime(this.endTime._d).time : '',
				objId: this.typeData.id,
				type: this.typeData.type,
				outBedAlarmTime: this.editHandleTimeVal ? this.$dateTime(this.editHandleTimeVal._d).time +
					':' +
					this.$dateTime(this.editHandleTimeVal._d).seconds : '',
				outBedEnable: this.leaveBedTimeSwitch ? 0 : 1,
				outBedPhoneEnable: this.leaveBedPhoneAlarmSwitch ? 0 : 1
			};
			this.loading = true;
			this.$post(
				'/api/monitorMgr/workTime',
				param,
				(res) => {
					if (res.code == 0) {
						this.$message.success('添加成功');
						this.getTableData();
						this.editHandleTimePopup = false;
						this.secondaryPopup = false;
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false;
				},
				(err) => {
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},
		// 修改监测仪时间段
		editWorkTime() {
			let param = {
				startTime: this.startTime._d ? this.$dateTime(this.startTime._d).time : '',
				endTime: this.endTime._d ? this.$dateTime(this.endTime._d).time : '',
				monitorTimeId: this.monitorTimeId.id,
				type: this.typeData.type,
				outBedAlarmTime: this.editHandleTimeVal ? this.$dateTime(this.editHandleTimeVal._d).time +
					':' +
					this.$dateTime(this.editHandleTimeVal._d).seconds : '',
				outBedEnable: this.leaveBedTimeSwitch ? 0 : 1,
				outBedPhoneEnable: this.leaveBedPhoneAlarmSwitch ? 0 : 1
			};
			this.loading = true;
			this.$put(
				'/api/monitorMgr/workTime',
				param,
				(res) => {
					if (res.code == 0) {
						this.$message.success('修改成功');
						this.getTableData();
						this.editHandleTimePopup = false;
						this.secondaryPopup = false;
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false;
				},
				(err) => {
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},
		// 修改离床异常时间
		editOutBedTimeout() {
			let param = {
				objId: this.typeData.id,
				outBedTimeout:
					this.$dateTime(this.editHandleTimeVal._d).time +
					':' +
					this.$dateTime(this.editHandleTimeVal._d).seconds,
				type: this.typeData.type,
			};
			this.loading = true;
			this.$put(
				'/api/monitorMgr/updateOutBedToiletTimeout',
				param,
				(res) => {
					if (res.code == 0) {
						this.$message.success('修改成功');
						this.getTableData();
						this.editAbnormalTimePopup = false;
						this.secondaryPopup = false;
					}
					this.loading = false;
				},
				(err) => {
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},

		// 二次确定弹窗取消
		secondaryCancel() {
			this.secondaryPopup = false;
		},
		// 修改离床异常时间按钮
		abnormalBtn(scope) {
			this.isClick1 = scope.children ? true : false;
			this.typeData = scope;
			this.editAbnormalTimePopup = true;
			this.editHandleTimeVal = scope.outBedTime
				? this.$moment(scope.outBedTime, 'HH:mm:ss')
				: '';
		},
		// 离床异常时间确定
		editAbnormalTimeOk(type) {
			if (this.isClick1) {
				this.secondaryPopup = true;
				this.typeVal = type;
			} else {
				this.editOutBedTimeout();
			}
		},
		// 离床异常时间取消
		editAbnormalTimeCancel() {
			this.editAbnormalTimePopup = false;
		},

		// 删除按钮
		delbtn(scope, item) {
			console.log(scope);
			this.delPopup = true;
			this.typeData = scope;
			this.delitem = item;
		},
		// 删除确定
		delOk() {
			if (this.typeData.type == 1) {
				this.delSecondaryOk();
			} else {
				this.delSecondaryPopup = true;
			}
		},
		// 删除取消
		delCancel() {
			this.delPopup = false;
		},
		// 删除二次确认取消
		delSecondaryCancel() {
			this.delSecondaryPopup = false;
		},
		// 删除二次确认提交
		delSecondaryOk() {
			this.loading = true;
			this.$delete(
				'/api/monitorMgr/workTime/' +
				this.typeData.type +
				'/' +
				this.delitem.id,
				{},
				(res) => {
					if (res.code == 0) {
						this.$message.success('删除成功');
						this.getTableData();
						this.delSecondaryPopup = false;
						this.delPopup = false;
					}
					this.loading = false;
				},
				(err) => {
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},
		disabledSeconds(selectedHour) {
			if (selectedHour == 0) {
				return 10
			}
		},
		getDisabledHours () {
			// let hours = []
			// let time = this.startTime
			// let timeArr = time.split(':')
			// for (var i = 0; i < parseInt(timeArr[0]); i++) {
			// 	hours.push(i)
			// }
			// return hours
			// return [1, 2, 3]
		},
		getDisabledMinutes (selectedHour) {
			// let time = this.startTime
			// let timeArr = time.split(':')
			// let minutes = []
			// if (selectedHour == parseInt(timeArr[0])) {
			// 	for(var i = 0; i < parseInt(timeArr[1]); i++) {
			// 	minutes.push(i)
			// 	}
			// }
			// return minutes
			if (selectedHour == 0) {
				// return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
			}
			
		},
		getDisabledSeconds (selectedHour, selectedMinute) {
			// let time = this.startTime
			// let timeArr = time.split(':')
			// let second = []
			// if (selectedHour == parseInt(timeArr[0]) && selectedMinute == parseInt(timeArr[1])) {
			// 	for(var i = 0; i <= parseInt(timeArr[2]); i++) {
			// 	second.push(i)
			// 	}
			// }
			// return second
		},
		leaveBedTimeSwitchChange(checked) {
			this.leaveBedTimeSwitch = checked;
		},
		leaveBedPhoneAlarmSwitchChange(checked) {
			this.leaveBedPhoneAlarmSwitch = checked;
		},

	},
};
</script>

<style lang="scss" scoped>
.main::v-deep {
	padding: 0 !important;
	// .tree-table tbody {
	//     .ant-table-row-cell-break-word {
	//         span:last-child {
	//             display: inline-block;
	//             min-width: 200px;
	//             text-align: left;
	//         }
	//     }
	// }

	.ant-table-thead>tr>th {
		background: #f0f0f0;
	}

	.ant-table-row:nth-child(even) {
		background: #fafafa;
	}

	.timeSlot {
		.timeSlotItem {
			display: flex;
			align-items: center;
			justify-content: left;
			margin-bottom: 10px;

			>span {
				color: #262626;
			}

			.addBtn {
				display: flex;
				align-items: center;
				cursor: pointer;
				color: #1890ff;
				margin-left: 10px;

				.iconBtn {
					margin-right: 6px;
				}
			}

			.addBtn:hover {
				.iconBtn {
					color: #0072db;
				}

				text-decoration: underline;
			}
		}

		.timeSlotItem:last-child {
			margin-bottom: 0;
		}

		.timeSlotItemPhone {
			width: 20px;
			height: 20px;
			margin-right: 5px;
		}
	}

	.abnormal {
		display: flex;
		align-items: center;
		justify-content: left;

		span {
			color: #262626;
		}
	}

	.toitet-edit {
		display: flex;
		align-items: center;

		span {
			margin-right: 8px;
		}
	}

	.tableIcon {
		color: #1890ff;
		font-size: 20px;
		cursor: pointer;
		margin-left: 10px;
	}

	.tableIcon:hover {
		color: #0072db;
	}

	.tableImg {
		width: 18px;
		height: 20px;
		cursor: pointer;
		background: url('../../assets/icon_trashCan_nor.png') no-repeat center;
	}

	.kong {
		width: 18px;
		height: 20px;
	}

	.tableImg:hover {
		background: url('../../assets/icon_trashCan_ove.png') no-repeat center;
	}
}

.Tips {
	display: flex;
	align-items: baseline;
	padding-top: 30px;

	p {
		font-size: 14px;
		color: #262626;
		line-height: 30px;
		margin-left: 8px;
	}
}

.addBtn,
.secondaryBtn {
	text-align: right;
}

.picker {
	padding-bottom: 20px;
	display: flex;
	align-items: center;

	.titleTime {
		margin-right: 10px;
	}
}

.toitet-pop-tips {
	margin-top: -20px;
	margin-left: 136px;
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #bfbfbf;

	.isLessTime {
		color: #ff4d4f;
	}
}

.toitet-btn {
	margin-top: 20px;
}

.delTips {
	.anticon {
		color: #faad14;
		margin-right: 10px;
	}
}

.delBtn {
	text-align: right;

	.ant-btn {
		height: 24px;
		line-height: 24px;
		border-radius: 2px;
		text-align: center;
		font-size: 14px;
	}
}

::v-deep .ant-time-picker-input[disabled] {
	background: #FFFFFF00;
}

</style>
